import { Component,  OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { UserWithBillingAddressFragment } from '../../../../generated/graphql.generated';
import { SharedModule } from '../../../shared/shared.module';

export interface CreateSelfSurveyDialogData {
  customer: UserWithBillingAddressFragment;
}

@Component({
  selector: 'app-send-self-survey-dialog',
  standalone: true,
  imports: [
    ButtonModule,
    SharedModule
  ],
  providers: [DialogService],
  templateUrl: './create-self-survey-link-dialog.component.html',
  styleUrl: './create-self-survey-link-dialog.component.scss'
})
export class CreateSelfSurveyLinkDialogComponent implements OnInit{

  customer?: UserWithBillingAddressFragment;

  constructor(
    private config: DynamicDialogConfig<CreateSelfSurveyDialogData>,
    private ref: DynamicDialogRef,
  ) {}

  ngOnInit(): void {
    this.customer = this.config.data?.customer;
  }

  sendInvite() {
    this.ref.close(true);
  }
}
